export default "__VITE_ASSET__cc3jLzE9__"